export enum RegionTypes {
    UNTRANSFORMED = 'UNTRANSFORMED',
    TRANSFORMED = 'TRANSFORMED',
    EFFECT = 'EFFECT',
}
